import {useEffect, useState} from 'react';
import {
useHistory,
    useLocation
} from "react-router-dom";

import {useTranslation} from "react-i18next";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import Input from '../../components/Form/Input';
import * as yup from "yup";
import {useAuth} from "../../services/use-auth";
import useMetaTags from "react-metatags-hook";
import trackPageView from "../../services/trackPageView";

export default function Login() {
    const { t } = useTranslation();
    const auth = useAuth();
    const history = useHistory();
    const location = useLocation();
    useMetaTags({
        title: t('app.title'),
        description: t('app.description'),
        metas: [
            { name: 'keywords', content: t('app.keywords') }
        ],
    });
    useEffect(() => {
        trackPageView(t('app.title'));
    });

    const schema = yup.object().shape({
        username: yup.string()
            .required(t('login.errors.required'))
            .matches(/^((([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))|((.+)?([1-9][0-9][0-9]{7}))$/,
                {message: t('login.errors.email')}),
        password: yup.string()
            .required(t('login.errors.required'))
    });
    const {register, handleSubmit, watch, errors} = useForm(
        {
            resolver: yupResolver(schema),
            mode: 'onBlur',
            reValidateMode: 'onBlur',
            defaultValues: {
                iAmDoctor: false,
                personalData: false,
                userAgreement: false,
            }
        }
    );
    const [showPassword, setShowPassword] = useState(false);
    const [loginErrors, setLoginErrors] = useState({});

    const onSubmit = (data) => {
        setLoginErrors({});
        let { from } = location.state || { from: { pathname: "/" } };
        auth.signIn(data.username, data.password, () => {history.replace(from);}, setLoginErrors);
    };

    return (
        <section className="section flex-center">
            <div className="authentication-form">
                <h1>{t('login.header')}</h1>
                <form className="form" onSubmit={handleSubmit(onSubmit)} id="login">
                    <div className="form-group block-static-height field_block">
                        <Input type="text"
                               name="username"
                               id="username"
                               inputClassName="form"
                               labelClassName="form-label"
                               label="login.labels.username"
                               watch={watch}
                               register={register}
                        />
                        { errors.username && <span className="error_text">{errors.username.message}</span> }
                    </div>
                    <div className="form-group block-static-height field_block mb0">
                        <Input type="password"
                               name="password"
                               id="password"
                               inputClassName="form"
                               labelClassName="form-label"
                               label="login.labels.password"
                               watch={watch}
                               register={register}
                        />
                        { errors.password && <span className="error_text">{errors.password.message}</span> }
                            <div className="hide-show-link">
                                { showPassword ?
                                    <span onClick={() => setShowPassword(false)}>{t('registration.password.hide')}</span> :
                                    <span onClick={() => setShowPassword(true)}>{t('registration.password.show')}</span>
                                }
                            </div>
                    </div>
                    <div className="forget-pass">
                        <a href="/account/restore-password"
                           className="forget-link">{t('login.password.forgot')}</a>
                    </div>
                    { loginErrors.errors && <div className="error-block">
                        <div className="error_text">
                            {t('login.errors.incorrectData')}
                        </div>
                    </div> }
                    <div className="submit-block">
                        <input type="submit" value={t('login.login')} className="btn" />
                    </div>
                    <div className="link-block js-login-form-registration-link">
                        <a rel="registration-form" href="/account/registration"
                           className="inline-block js-link-to-form">{t('login.register')}</a>
                    </div>
                </form>

            </div>
        </section>
    )
}
